import { useState, useCallback, useEffect } from 'react';
import { apiGet } from 'src/utils/api';

let currentConnectionStatus: boolean | null = null;
let currentlyLoading: boolean = false;
const listeners = new Set<() => void>();

const notifyListeners = () => {
  listeners.forEach(listener => listener());
};

export const useConnectionStatusPortal = () => {
  const [ connectionStatus, setConnectionStatus ] = useState<boolean | null>(currentConnectionStatus);
  const [ isLoading, setIsLoading ] = useState<boolean>(currentlyLoading);

  const updateConnectionStatus = useCallback((orgId: number) => {
    currentlyLoading = true;
    fetchConnectionStatus(orgId).then((status: boolean) => {
      currentConnectionStatus = status;
      currentlyLoading = false;
      notifyListeners();
    });
  }, []);

  const blockIfNotConnected = useCallback(() => {
    if (connectionStatus === null) {
      return;
    }
    if (!connectionStatus && !isLoading) {
      window.location.href = '/error';
    }
  }, [connectionStatus, isLoading]);

  useEffect(() => {
    const listener = () => {
      setConnectionStatus(currentConnectionStatus);
      setIsLoading(currentlyLoading);
    };
    listeners.add(listener);
    listener();
    return () => {
      listeners.delete(listener);
    };
  }, []);

  return {
    connectionStatus,
    isLoading,
    updateConnectionStatus,
    blockIfNotConnected
  };
};

const fetchConnectionStatus = async (orgId: number): Promise<boolean> => {
  let connectionStatus = false;
  if (!orgId) {
    return connectionStatus;
  }

  try {
    const response = await apiGet(`/api/organizations/${orgId}/connection-status`);
    const data = await response.json();
    if (data.isConnected) {
      connectionStatus = data.isConnected;
    }
  } catch (error) {
    console.error("Error fetching connection status:", error);
    connectionStatus = false;
  } finally {
    return connectionStatus || false;
  }
};

export default fetchConnectionStatus;
